_               = require 'underscore'
React           = require 'react'
ReactDOM        = require 'react-dom'
Xrespond        = require '../scripts/xrespond'
ClickSource     = require '../lib/click_source'
DropdownDevice  = require '../components/dropdown_device'
CustomDevice    = require '../components/custom_device'
DropdownToolbar = require '../components/dropdown_toolbar'

module.exports = DropdownDevices = React.createClass
  getInitialState: ->
    devices: @props.devices
    search: ''
    localClick: false

  search: (value) ->
    devices = Xrespond.devices_search(value)
    @setState
      search: value
      devices: devices

  handleInputChange: (e) ->
    @search e.target.value

  handleClear: ->
    @setState localClick: true
    @search ''

  render: ->
    that = this
    sections = _.map(@state.devices, (list, label) ->
      devices = list.map((o, j) ->
        React.createElement(DropdownDevice, {"key": (o.name), "name": (o.name), "name_marked": (o.name_marked), "width": (o.width), "height": (o.height), "handleSubmit": (that.props.handleSubmit)})
      )
      React.createElement("li", {"className": "menu__section", "key": (label)},
        React.createElement("div", {"className": "menu__title"}, (label)),
        React.createElement("ol", {"className": "menu-list"},
          (devices)
        )
      )
    )
    empty = React.createElement("li", {"className": "menu__section"},
              React.createElement("ol", {"className": "menu-list"},
                React.createElement(DropdownDevice, {"name": "No devices found", "subtitle": "Show all devices", "handleSubmit": (@handleClear)})
              )
            )

    React.createElement("div", {"className": "dropdown device-control__dropdown"},
      React.createElement("div", {"className": "device-search"},
        React.createElement("div", {"className": "device-search__title"}, "Search for device"),
        React.createElement("input", {"autoFocus": true, "className": "text-input text-input--small device-search__text-input", "onChange": (@handleInputChange), "placeholder": "Enter device name", "value": (@state.search)})
      ),
      React.createElement("ol", {"className": "menu"},
        (if _.isEmpty(@state.devices) then empty else sections)
      ),
      React.createElement(CustomDevice, {"id": (@props.id)}),
      React.createElement(DropdownToolbar, {"reset": (@props.reset), "id": (@props.id)})
    )

  componentDidMount: ->
    document.addEventListener 'click', @documentClickHandler

  componentWillUnmount: ->
    document.removeEventListener 'click', @documentClickHandler

  localClick: ->
    # Offer a bailout for global click handling when we need to handle a
    # local click on an element that is destroyed before the global event is fired.
    # I.e, the 'No such device...' click, which should reset devices
    # without hiding the whole dropdown.
    if @state.localClick == true
      @setState localClick: false
      true
    else
      false

  documentClickHandler: (evt) ->
    return if @localClick()

    if ClickSource.isGlobal(evt, @) then @props.handleBlur()



// WEBPACK FOOTER //
// ./~/cjsx-loader!./app/js/components/dropdown_devices.cjsx